export const CUSTOMER_SERVICE_CUSTOMER_POLICY_PREFIX = 'CustomerService.Customer.';
export const CUSTOMER_SERVICE_VENDOR_POLICY_PREFIX = 'CustomerService.Vendor.';

export type OrganizationSettingsPermissionRoute = {
  permissionName?: string | string[];
  name?: string | string[];
};

export const getOrganizationSettingsPermissionKeys = (
  route: OrganizationSettingsPermissionRoute,
): string[] => {
  const permissionKey = route.permissionName ?? route.name;
  if (permissionKey == null || permissionKey === '') return [];
  return Array.isArray(permissionKey) ? permissionKey : [permissionKey];
};

export const hasOrganizationSettingsPermission = (
  route: OrganizationSettingsPermissionRoute,
  grantedPolicies: Record<string, boolean> | null | undefined,
  userRouteList: string[],
): boolean => {
  const permissionKeys = getOrganizationSettingsPermissionKeys(route);
  if (permissionKeys.length === 0) return false;

  return permissionKeys.some((permissionKey) => {
    const customerPolicyKey = `${CUSTOMER_SERVICE_CUSTOMER_POLICY_PREFIX}${permissionKey}`;
    const vendorPolicyKey = `${CUSTOMER_SERVICE_VENDOR_POLICY_PREFIX}${permissionKey}`;

    if (grantedPolicies?.[customerPolicyKey] === true || grantedPolicies?.[vendorPolicyKey] === true) {
      return true;
    }

    return userRouteList.includes(permissionKey);
  });
};
